import { buildApiUrlQueryParams } from "../../../../features/dataFormatFunctions/dataFormatter";
import { baseAPI } from "../baseApi";

type FetchAxisLengthArgs = {
    RoadId?: string, 
    PathId?: string, 
    PathType?: 1 | 2 | 3 | 4, 
    AxisType?: 1 | 2 | 3 | 5 | 6 | 7| 8
}

export const pathsApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение всех направлений
        fetchRoads: builder.query<any, any>({
            query: () => ({
                url: `address/Roads`
            })
        }),
        // запрос на получение всех направлений
        fetchPaths: builder.query<any, any>({
            query: () => ({
                url: `address/Paths`
            })
        }),
        // запрос на получение всех направлений
        fetchAxisLength: builder.query<any, FetchAxisLengthArgs>({
            query: ({ RoadId, PathId, PathType, AxisType }) => ({
                url: `address/AxisLength${buildApiUrlQueryParams({ RoadId, PathId, PathType, AxisType })}`
            })
            // PathType in
            //  1 - Основное направление
            //  2 - Подъезд
            //  3 - Альтернативное направление (объезд)
            //  4 - Обратное направление при раздельном трассировании
            // AxisType in 
            //   1- Проектная ось (по ней считается длина дороги)
            //   2 -  Ось прямого направления дороги первой категории
            //   3 -  Ось обратного направления дороги первой категории
            //   5 -  Ось дополнительной (коллекторной) дороги прямого направления
            //   6 -  Транспортная развязка
            //   7 - Ось дополнительной (коллекторной) дороги обратного направления
            //   8 - Ось дополнительной проезжей части
        }),
        // запрос на получение всех id всех направлений c геометрией
        fetchIdsOfPathsWithGeometry: builder.query<string[], any>({
            query: () => ({
                url: `checkPathGeometry`
            })
        }),
    })
})

export const {
    useFetchPathsQuery,
    useLazyFetchPathsQuery,
    useFetchRoadsQuery,
    useLazyFetchRoadsQuery,
    useFetchAxisLengthQuery,
    useFetchIdsOfPathsWithGeometryQuery,
    useLazyFetchIdsOfPathsWithGeometryQuery
} = pathsApiSlice